import useAuth from "../../hooks/useAuth";

export default function Profile() {
  const { auth } = useAuth();

  const user = auth?.user;

  return (
    <div className="bg-white flex flex-col items-center">
      <div className="bg-white w-full px-4 py-4">
        <div className="flex flex-col">
          <img
            src={user?.profile_image || "/default-avatar.png"}
            alt={user?.username}
            className="w-28 h-28 rounded-full border-4 border-indigo-200 object-cover"
          />
          <h2 className="mt-4 text-2xl font-bold text-gray-800">
            {user?.firstname} {user?.lastname}
          </h2>
          <p className="text-sm text-gray-500">{user?.role?.name}</p>
          <span
            className={`mt-2 px-3 py-1 w-[200px] rounded-full text-xs font-medium ${
              user?.status === "Active"
                ? "bg-green-100 text-green-700"
                : "bg-red-100 text-red-700"
            }`}
          >
            {user?.status}
          </span>
        </div>
        <div className="mt-8 grid grid-cols-1 sm:grid-cols-2 gap-6 text-sm">
          <div>
            <p className="text-gray-500">Email</p>
            <p className="font-medium text-gray-800">{user?.email}</p>
          </div>
          <div>
            <p className="text-gray-500">Username</p>
            <p className="font-medium text-gray-800">{user?.username}</p>
          </div>
          <div>
            <p className="text-gray-500">Phone</p>
            <p className="font-medium text-gray-800">{user?.phone || "—"}</p>
          </div>
          <div>
            <p className="text-gray-500">Country</p>
            <p className="font-medium text-gray-800">{user?.country || "—"}</p>
          </div>
          <div>
            <p className="text-gray-500">Public ID</p>
            <p className="font-medium text-gray-800">{user?.public_id}</p>
          </div>
          <div>
            <p className="text-gray-500">Login Times</p>
            <p className="font-medium text-gray-800">{user?.logintimes}</p>
          </div>
          <div>
            <p className="text-gray-500">Created At</p>
            <p className="font-medium text-gray-800">
              {new Date(user?.createdAt).toLocaleDateString()}
            </p>
          </div>
          <div>
            <p className="text-gray-500">Last Updated</p>
            <p className="font-medium text-gray-800">
              {new Date(user?.updatedAt).toLocaleDateString()}
            </p>
          </div>
        </div>
        <div className="my-6 border-t" />
        <div>
          <h3 className="text-lg font-semibold text-gray-800 mb-3">
            Permissions
          </h3>
          <div className="flex flex-wrap gap-2">
            {auth?.roles?.map((role) => (
              <span
                key={role.id}
                className="px-3 py-1 text-xs bg-indigo-100 text-indigo-700 rounded-full"
              >
                {role.name}
              </span>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
}
